import Utils from '../modules/utils'
import 'jquery-validation'
import '../modules/custom.jquery-validate'

const HsForms = (($) => {
  let HsForms = {
    init () {
      // Enables toggling of debug logging from console
      function log (msg) {
        if (window.hubspotDebug) {
          console.log(msg) // eslint-disable-line no-console
        }
      }

      // Globals
      const hsForms = {}
      const formSubmitBaseUrl = 'https://ksr7rci03h.execute-api.us-east-1.amazonaws.com/prod/forms'
      const contactSubmitBaseUrl = 'https://ksr7rci03h.execute-api.us-east-1.amazonaws.com/prod/profile'
      const distinctFieldNames = [
        'lead_source',
        'leadfeeder_version',
        'zip',
        'firstname',
        'lastname',
        'email',
        'phone',
        'gclid',
        'msclkid',
        'infinity_vid',
        'page_lead_submitted_on',
        'consultation_requested'
      ]

      let infinityVID = null

      log(`Form submission base URL: ${formSubmitBaseUrl}`)

      const hsContext = {
        hutk: Utils.getCookie('hubspotutk'),
        pageUrl: window.location.href,
        pageName: document.title,
        pageId: window.hsVars ? window.hsVars.page_id : ''
      }

      log(`HubSpot context: ${JSON.stringify(hsContext)}`)

      // Initialize form submit listeners
      initialize()

      function initialize () {
        // Populate hsForms: needs to run _beforeInit() because _beforeInit() makes use of hsForms
        _populateHsForms()
        __beforeInit()

        $('form[data-hs-form-id]').each(function () {
          const $form = $(this)
          const hsFormID = $form.data('hs-form-id')

          validate($form)

          $form.submit((e) => {
            e.preventDefault()
            e.stopImmediatePropagation()

            if ($form.valid()) {
              serializeFormData($form)

              if ($form.attr('data-sub-form') === undefined) {
                submitHsForm($form)
              }
            }
          })

          if (infinityVID !== null) {
            log('InfinityVID set before initializing hs forms')
            hsForms[hsFormID] = hsForms[hsFormID].concat([{
              name: 'infinity_vid',
              value: infinityVID
            }])
          }
        })

        __afterInit()
      }

      function _populateHsForms () {
        $('form[data-hs-form-id]').each(function () {
          const $form = $(this)
          if ($form && $form.data('hs-form-id')) {
            const hsFormID = $form.data('hs-form-id')
            hsForms[hsFormID] = []
          }
        })
      }

      function __beforeInit () {
        populatePageLeadSubmittedOn()
        populateExistingVid()
      }

      function __afterInit () {
        // Set VID when we get it
        $('body').on('infinityVidSet', (e) => {
          setFormVID(e.detail)
        })

        if (!hsContext['ipAddress']) {
          $.getJSON('https://api.ipify.org/?format=json', (data) => {
            hsContext['ipAddress'] = data.ip
            log(`HubSpot context updated: ${JSON.stringify(hsContext)}`)
          })
        }

        log(`HubSpot forms initialized: ${JSON.stringify(hsForms)}`)
      }

      function validate ($form) {
        $form.validate()
      }

      // Find and store serialized form data
      // -- allows for multi-pane forms
      // -- always runs at least once
      function serializeFormData ($form) {
        const id = $form.data('hs-form-id')
        let fields = {}

        $form.find('input, textarea, select').each(() => {
          fields[$(this).attr('name')] = null
        })

        fields = Object.keys(fields)

        let existingFields = []

        hsForms[id].forEach((input) => {
          if (!fields.some((field) => {
            return field === input.name
          })) {
            existingFields.push(input)
          }
        })

        hsForms[id] = existingFields.concat($form.serializeArray())
        log(`HubSpot form data updated: ${JSON.stringify(hsForms)}`)
        $form.trigger('subFormSubmitSuccess')
      }

      // Clear serialized form data store, usually
      // called after a successful submission.
      function clearKnownFormData (id) {
        hsForms[id] = []
      }

      function prepareHsFormSubmit (id) {
        const hsUtkCookie = Utils.getCookie('hubspotutk')
        let hsPageId = window.hsVars ? window.hsVars.page_id : ''
        let formData = {}

        // Format data into name/value pairs
        hsForms[id].forEach((input) => {
          if (formData[input.name] && !distinctFieldNames.includes(input.name)) {
            if (!formData[input.name].includes(input.value)) {
              formData[input.name] += (`;${input.value}`)
            }
          } else {
            formData[input.name] = input.value
          }
        })

        // Update tracking code in case it's been added after page load
        if (hsUtkCookie['hutk']) {
          hsContext['hutk'] = hsUtkCookie
          log(`HubSpot context updated: ${JSON.stringify(hsContext)}`)
        }

        // Update page id in case it's been added after page load
        if (!hsContext['pageId'] && hsPageId) {
          hsContext.page_id = hsPageId
          log(`HubSpot context updated: ${JSON.stringify(hsContext)}`)
        }

        // Update/Call identify on hubspot tracking and call track page view
        // https://developers.hubspot.com/docs/methods/tracking_code_api/identify_visitor
        if (formData.hasOwnProperty('email') && formData['email']) {
          const email = formData['email']
          const zip = formData['zip']
          const vid = getExistingVid()
          window._hsq = window._hsq || []
          if (email && zip && vid) {
            window._hsq.push(['identify', {
              email: email,
              zip: zip,
              infinity_vid: vid
            }])
          } else if (email && vid) {
            window._hsq.push(['identify', {
              email: email,
              infinity_vid: vid
            }])
          } else if (email) {
            window._hsq.push(['identify', {
              email: email
            }])
          }
          // Track the page view for leadfeeder (required to push identity to hubspot)
          window._hsq.push(['setPath', '/leadfeeder'])
          window._hsq.push(['trackPageView'])
        }

        formData['hs_context'] = JSON.stringify(hsContext)

        return formData
      }

      function submitHsForm ($form) {
        const id = $form.data('hs-form-id')
        const formData = prepareHsFormSubmit(id)

        // Short-circuit if running in debug mode, and only
        // log out to the console. Do not submit to HS.
        if (window.hubspotDebug) {
          clearKnownFormData(id)
          log(hsContext)
          log(`Form ${id} submitted`)
          return
        }

        //
        // Submit via Forms API
        //
        if (!$form.data('hs-api') || /forms/i.test($form.data('hs-api'))) {
          toggleSubmitButtonDisabled($form, true)
          $.ajax({
            url: `${formSubmitBaseUrl}/${id}`,
            method: 'POST',
            crossDomain: true,
            cache: false,
            contentType: 'application/x-www-form-urlencoded',
            data: $.param(formData)
          }).done((data, status, xhr) => {
            onFormSuccess($form, data, status, xhr)
          }).fail((xhr, status, error) => {
            onFormError($form, xhr, status, error)
          }).always((xhr, status, error) => {
            log(`XHR Details: ${xhr}`)
            clearKnownFormData(id)
          })
        }

        //
        // Submit via Contacts API
        //
        if ($form.data('hs-api') && /contacts/i.test($form.data('hs-api'))) {
          if (
            (formData.email && formData.email !== '') &&
            (formData.phone && formData.phone !== '')
          ) {
            const properties = []
            const propertyKeys = Object.keys(formData)
            propertyKeys.map(key => {
              if (formData[key] !== '' && key !== 'hs_context') {
                properties.push({'property': key, 'value': formData[key]})
              }
            })
            toggleSubmitButtonDisabled($form, true)
            $.ajax({
              url: `${contactSubmitBaseUrl}/${formData.email}`,
              method: 'POST',
              crossDomain: true,
              cache: false,
              contentType: 'application/json',
              dataType: 'json',
              data: JSON.stringify({
                'properties': properties
              })
            }).done((data, status, xhr) => {
              onFormSuccess($form, data, status, xhr)
            }).fail((xhr, status, error) => {
              onFormError($form, xhr, status, error)
            }).always((xhr, status, error) => {
              log(`XHR Details: ${xhr}`)
              clearKnownFormData(id)
            })
          }
        }
      }

      /**
       * Toggle Form Submit Button
       * @param {*} $form
       * @param {Boolean} disabled
       */
      function toggleSubmitButtonDisabled ($form, disabled) {
        const submitButtonId = $form.data('hs-submit-button')
        const $submitButton = $(`#${submitButtonId}`)
        if ($submitButton) {
          if (disabled) {
            $submitButton.prop('disabled', true).addClass('disabled')
          } else {
            $submitButton.prop('disabled', false).removeClass('disabled')
          }
        }
      }

      /**
       * Handler for ajax form success
       * @param {*} $form
       * @param {*} data
       * @param {*} status
       * @param {*} xhr
       */
      function onFormSuccess ($form, data, status, xhr) {
        log(`Form ${$form.data('hs-form-id')} submitted. Response status: ${status}.`)
        toggleSubmitButtonDisabled($form, false)
        $form.trigger('hubspotFormSubmitSuccess')
      }

      /**
       * Handler for ajax form error
       * @param {*} $form
       * @param {*} xhr
       * @param {*} status
       * @param {*} error
       */
      function onFormError ($form, xhr, status, error) {
        if (isJSONParseErrorSuccess(status, xhr)) {
          onFormSuccess($form, {}, status, xhr)
        } else {
          log(`Form ${$form.data('hs-form-id')} ERROR. Response status: ${status}.`)
          $form.trigger('hubspotFormSubmitFailure')
        }
      }

      /**
       * Check for success 200 with empty JSON response
       * @param {*} status
       * @param {*} xhr
       * @returns boolean true if it is parse error or false otherwise
       */
      function isJSONParseErrorSuccess (status, xhr) {
        let contentType = xhr.getResponseHeader('content-type')
        if (!!status && status === 'parsererror' && xhr.status === 200 && !!contentType && contentType === 'application/json') {
          return true
        }
        return false
      }

      function populatePageLeadSubmittedOn () {
        const pageLeadSubmittedOn = []

        const origin = window.location.origin || ''
        const path = window.location.pathname || ''

        pageLeadSubmittedOn.push({
          name: 'page_lead_submitted_on',
          value: `${origin}${path}`
        })

        Object.keys(hsForms).forEach(function (key) {
          hsForms[key] = hsForms[key].concat(pageLeadSubmittedOn)
        })
      }

      function getExistingVid () {
        // eslint-disable-next-line no-extra-boolean-cast
        if (!!window._ictt) {
          const vid = window._ictt.push(['_get', 'ictvid'])
          // eslint-disable-next-line no-extra-boolean-cast
          if (!!vid) {
            return vid
          }
          console.error('Error Retrieving Infinity VID')
        }
        console.error('Missing Infinity Tracking Code')
      }

      function populateExistingVid () {
        const vid = getExistingVid()
        setFormVID(vid)
      }

      function setFormVID (vid) {
        for (let form in hsForms) {
          if (hsForms.hasOwnProperty(form)) {
            hsForms[form] = hsForms[form].concat([{
              name: 'infinity_vid',
              value: vid
            }])
          }
        }
        log(`VID set: ${JSON.stringify(hsForms)}`)
      }
    }
  }

  return HsForms
})(jQuery)

export default HsForms
